module.exports = __webpack_public_path__ + "img/pin1.prt.55fa348d.jpg";